import { normalizeUri } from '../../../utils/utils';
import { getMediaTypeByExtension } from '../../../utils/extensions';
import { ItemKind } from '../../../constants/ItemKind';
export const toItem = data => {
  const {
    imageMediaMetadata = {}
  } = data;
  const {
    width,
    height
  } = imageMediaMetadata;
  return {
    id: data.id,
    name: data.title,
    kind: ItemKind.File,
    source: 'drive',
    mediaType: getMediaTypeByExtension(data.fileExtension),
    fileUrl: normalizeUri(data.webContentLink || data.selfLink || data.downloadUrl || data.thumbnailLink),
    thumbnailUrl: data.thumbnailLink ? normalizeUri(data.thumbnailLink) : null,
    previewUrl: data.thumbnailLink ? normalizeUri(data.thumbnailLink) : null,
    createdAt: data.createdDate,
    tags: [],
    ...(height === undefined ? {} : {
      height
    }),
    ...(width === undefined ? {} : {
      width
    })
  };
};